import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPrescriptions } from '../../../Redux/PrescriptionSlice';
import Table from '../../dataUi/Table';
import { InfinitySpin } from 'react-loader-spinner';
import { BsEye } from 'react-icons/bs';

const PrescriptionTableInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { prescriptions, loading, error } = useSelector((state) => state.prescriptions);
  const { id, branch_id } = useSelector((state) => state.auth);

  // Status configuration for filtering
  const statusConfig = {
    pending: {
      label: 'Pending',
      className: 'bg-yellow-100 text-yellow-800'
    },
    preparing: {
      label: 'Preparing',
      className: 'bg-blue-100 text-blue-800'
    },
    is_ready: {
      label: 'Ready',
      className: 'bg-green-100 text-green-800'
    },
    picked_up: {
      label: 'Picked Up',
      className: 'bg-green-100 text-green-800'
    },
    cancelled: {
      label: 'Cancelled',
      className: 'bg-red-100 text-red-800'
    }
  };

  // Filter options for status
  const filterOptions = [
    { label: 'Pending', value: 'pending' },
    { label: 'Preparing', value: 'preparing' },
    { label: 'Ready', value: 'is_ready' },
    { label: 'Picked Up', value: 'picked_up' },
    { label: 'Cancelled', value: 'cancelled' }
  ];

  useEffect(() => {
    console.log('Fetching prescriptions with:', { userId: id, branchId: branch_id });
    dispatch(fetchPrescriptions({
      userId: id,
      branchId: branch_id
    }));
  }, [dispatch, id, branch_id]);

  const headers = [
    { key: 'no', label: 'No.', sortable: false },
    // { key: 'id', label: 'ID', sortable: true },
    { key: 'date_created', label: 'Date Created', sortable: true, },
    { key: 'order_id', label: 'Order ID', sortable: true },
    { key: 'medication_name', label: 'Medication Name', sortable: true, tooltipEnabled: true },
    { key: 'patient_details', label: 'Patient Details', sortable: false, tooltipEnabled: true },
    { key: 'patient_number', label: 'Patient Number', sortable: true },
    { key: 'patient_address', label: 'Patient Address', sortable: false },
    { key: 'date_issued', label: 'Date Issued', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
  ];

  const actions = [
    {
      label: 'View',
      variant: 'primary',
      icon: <BsEye />,
      onClick: (row) => {
        navigate(`/retail/prescriptions/view-prescription/${row.id}`, {
          state: { requiredRoles: ['prescriptionViewer', 'prescriptionWriter', 'prescriptionAdmin'] }
        });
      },
      className: "bg-green-500 hover:bg-green-600 text-white p-1 h-6 px-1.5 rounded-md text-sm shadow-lg hover:shadow-xl transition-all duration-300"
    }
  ];

  const tableRows = prescriptions.map((prescription, index) => ({
    no: index + 1,
    id: prescription.id,
    date_created: new Date(prescription.created_at).toLocaleDateString(),
    order_id: prescription.order_id,
    medication_name: prescription.medications?.[0]?.name || 'N/A',
    patient_details: prescription.patient ?
      `${prescription.patient.first_name || ''} ${prescription.patient.last_name || ''} (${prescription.patient.date_of_birth ? new Date(prescription.patient.date_of_birth).toLocaleDateString() : 'N/A'}, ${prescription.patient.gender || 'N/A'})` :
      `${prescription.patient_first_name || ''} ${prescription.patient_last_name || ''} (${prescription.patient_date_of_birth ? new Date(prescription.patient_date_of_birth).toLocaleDateString() : 'N/A'}, ${prescription.patient_gender || 'N/A'})`,
    patient_number: prescription.patient?.phone_number || prescription.patient_phone_number || 'N/A',
    patient_address: prescription.patient?.address || prescription.patient_address || 'N/A',
    date_issued: prescription.date_issued ? new Date(prescription.date_issued).toLocaleDateString() : 'N/A',
    status: prescription.status,
  }));

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen text-red-500">
        Error: {error}
      </div>
    );
  }

  return (
    <div className='absolute w-full h-full font-lufga'>
      <div className='ml-5 mr-10'>
        {loading && (
          <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm">
            <InfinitySpin color="#059212" loading={loading} size={40} />
          </div>
        )}
        {!loading && (
          <Table
            headers={headers}
            rows={tableRows}
            actions={actions}
            // grid={true}
            title="Prescriptions"
            itemsPerPage={15}
            emptyMessage="No prescriptions found"
            headerBgColor="bg-green-200"
            filterOptions={filterOptions}
            statusConfig={statusConfig}
          />
        )}
      </div>
    </div>
  );
};

export default PrescriptionTableInfo;